// Returns the device's public IP address as a string, or null if it
// can't be determined. The lookup is cached in a module-level promise so
// the network call only happens once per page load — subsequent callers
// get the result immediately.
//
// Source: https://api.ipify.org (free, CORS-enabled, no API key).
//
// Safe to import on the server: returns null there because `fetch` and
// `window` are unavailable, and the encryption-on-the-server path
// doesn't need a client IP.

let cached: Promise<string | null> | null = null;

export function getClientIp(): Promise<string | null> {
  if (typeof window === "undefined" || typeof fetch === "undefined") {
    return Promise.resolve(null);
  }
  if (cached) return cached;

  cached = fetch("https://api.ipify.org?format=json", {
    method: "GET",
    cache: "force-cache",
  })
    .then((res) => {
      if (!res.ok) throw new Error(`ipify status ${res.status}`);
      return res.json();
    })
    .then((data: any) => (data && typeof data.ip === "string" ? data.ip : null))
    .catch(() => null);

  return cached;
}
